<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categories" [label]="themeOptions.optionsConfiguration[optionType].label" [information]="themeOptions.options().tooltips.bodyFontColor">
  <div app-theme-option-content>
    <app-color-picker [itemColor]="color" [color]="themeOptions.options().tooltips.bodyFontColor" (sendColor)="receiveValue($event)"></app-color-picker>
  </div>
</app-theme-option>